<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/locations">Locations</a></li>
  <li class="breadcrumb-item"><a routerLink="/locationCollections/{{locationCollection.id}}/locations">{{locationCollection.name}}</a></li>
  <li class="breadcrumb-item active">Edit Location</li>
</ol>

<div>
  <form class="form-horizontal col col-sm-6" >
    <table class="table table-striped">
      <tbody>
        <tr>
          <th>Name</th>
          <td>
            <input type="text"
                      class="form-control"
                      name="name"
                      [(ngModel)]="location.name"
                      placeholder="Name">
          </td>
        </tr>
        <tr>
          <th>Address</th>
          <td>
            <input id="address-input" type="text" [placeholder]="location.current_address" />
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="action-wrap text-left">
      <button type="button" class="btn btn-danger" (click)="deleteLocation()">Delete</button>
      <button type="button" class="btn btn-primary pull-right" (click)="saveLocation()">Save</button>
      <button type="button" class="btn btn-default pull-right" routerLink="/locationCollections/{{locationCollection.id}}/locations">Cancel</button>
    </div>
  </form>
</div>
